module.exports = __webpack_public_path__ + "static/media/gutter.ed6e35b3.png";